@let tenant = currentTenant();
<div class="menu-wrapper" [class.expanded]="isExpanded" [class.no-transition]="viewportJump()" [class.handset]="layout.isHandset()" (mouseenter)="onMenuHover()" (mouseleave)="onMenuLeave()">
  <div class="menu-card">
    <!-- Header: tenant logo/name + toggle button -->
    <div class="menu-header" [class.menu-header-open]="isOpen">
      @if (isOpen) {
        <div class="tenant-button" [dropdownTrigger]="tenantMenu"
          [class.tenant-button-active]="tenantMenu.display">
          <div class="tenant-logo-wrapper">
            @if (tenantLogoUrl) {
              <img [src]="tenantLogoUrl" alt="" class="tenant-logo">
            } @else {
              <img [ngSrc]="environment.applicationLogo" alt="" width="24" height="22" class="tenant-logo-fallback">
            }
          </div>
          <span class="tenant-name">{{ tenant?.configuration?.name }}</span>
          <div class="tenant-chevrons">
            <img src="assets/icons/chevron-right.svg" alt="" class="chevron-up">
            <img src="assets/icons/chevron-right.svg" alt="" class="chevron-down">
          </div>
        </div>
        <button class="toggle-btn" (click)="onToggleClick()"
          [title]="(layout.isHandset() ? 'global.close' : 'menu.fold') | translate">
          @if (layout.isHandset()) {
            <img src="assets/icons/close.svg" alt="" class="filter-darkgrey close-icon">
          } @else {
            <img src="assets/icons/layout-left.svg" alt="" class="filter-darkgrey toggle-icon">
          }
        </button>
      } @else {
        <div class="collapsed-header flex-center">
          <button class="toggle-btn toggle-btn-centered" [class.visible]="isHovered" (click)="toggleMenu()" [tooltip]="'menu.unfold' | translate" tooltipPosition="left">
            <img src="assets/icons/layout-left.svg" alt="" class="filter-darkgrey toggle-icon">
          </button>
          <div class="logo-collapsed" [class.visible]="!isHovered"
            [dropdownTrigger]="tenantMenu">
            @if (tenantLogoUrl) {
              <img [src]="tenantLogoUrl" alt="" class="tenant-logo-small">
            } @else {
              <img [ngSrc]="environment.applicationLogo" alt="" width="24" height="22" class="tenant-logo-small">
            }
          </div>
        </div>
      }
    </div>

    <!-- Scrollable nav area. Wrapped in overlayscrollbars-ngx for a
    Notion-style overlay scrollbar that floats on top of content and
    fades in only while the user is interacting with the menu. -->
    <overlay-scrollbars class="menu-scroll-host" [options]="overlayScrollbarsOptions">
      <div class="menu-scroll">
	    <!--Recherche-->
	    <div class="menu-item" [class.collapsed-item]="!isOpen" [class.menu-locked]="suspended()"
			 (click)="openResearchBar()"
	         [title]="!isOpen ? ('menu.research' | translate) : ''" [tooltip]="'menu.research' | translate"
			 [tooltipDisabled]="isOpen" tooltipPosition="left">
			<img src="assets/icons/global-research/search.svg" alt="" class="menu-icon filter-darkgrey">
			@if (isOpen) {
				<span class="menu-label">{{ 'menu.research' | translate }}</span>
				@if (suspended()) {
					<img src="assets/icons/lock-01.svg" alt="" class="lock-icon lock-on-hover">
				} @else {
					<span class="font-M fw-500 grey">{{ researchShortcutHint }}</span>
				}
			}
		</div>
        <!-- Accueil -->
        <div class="menu-item" [class.selected]="isCurrentPage(HOME_URL)" [class.collapsed-item]="!isOpen"
          (click)="goTo(HOME_URL)" [title]="!isOpen ? ('menu.home' | translate) : ''" [tooltip]="'menu.home' | translate" [tooltipDisabled]="isOpen" tooltipPosition="left">
          <img src="assets/icons/menu/home.svg" alt="" class="menu-icon" [class.filter-darkgrey]="!isCurrentPage(HOME_URL)">
          @if (isOpen) {
            <span class="menu-label">{{ 'menu.home' | translate }}</span>
          }
        </div>

        <!-- Prism -->
        @if (isPrismFlagEnabled && hasChatUse() && isChatEnabled()) {
          <div class="menu-item" [class.selected]="isCurrentPage(PRISM_URL)" [class.collapsed-item]="!isOpen" [class.menu-locked]="suspended()"
            (click)="goTo(PRISM_URL)" [title]="!isOpen ? ('menu.prism' | translate) : ''" [tooltip]="'menu.prism' | translate" [tooltipDisabled]="isOpen" tooltipPosition="left">
            <img src="assets/icons/menu/prism.svg" alt="" class="menu-icon" [class.filter-darkgrey]="!isCurrentPage(PRISM_URL)">
            @if (isOpen) {
              <span class="menu-label">{{ 'menu.prism' | translate }}</span>
            }
            @if (suspended()) {
              <img src="assets/icons/lock-01.svg" alt="" class="lock-icon lock-on-hover">
            }
          </div>
        }

        <!-- Analyse -->
        @if (hasAnyDashboardRead) {
          <div class="menu-item"
            [class.selected]="isAnyDashboardCurrentPage"
            [class.collapsed-item]="!isOpen" [class.menu-locked]="suspended()"
            (click)="goTo(firstAvailableDashboardUrl)"
            [title]="!isOpen ? ('menu.analyze' | translate) : ''" [tooltip]="'menu.analyze' | translate" [tooltipDisabled]="isOpen" tooltipPosition="left">
            <img src="assets/icons/menu/analyze.svg" alt="" class="menu-icon"
              [class.filter-darkgrey]="!isAnyDashboardCurrentPage">
			  <div class="flex a-i-c gap-S">
				  @if (isOpen) {
					  <span class="menu-label">{{ 'menu.analyze' | translate }}</span>
				  }
				  @if (showNewsBadge() && !suspended()) {
					  <span class="news-dot"></span>
				  }
			  </div>
			  @if (suspended()) {
				  <img src="assets/icons/lock-01.svg" alt="" class="lock-icon lock-on-hover">
			  }

          </div>
        }

        <!-- Schemas -->
        @if (hasAnyDiagramRead) {
          <div class="menu-item" [class.selected]="isCurrentPage(DIAGRAMS_URL)" [class.collapsed-item]="!isOpen" [class.menu-locked]="suspended()"
            (click)="goTo(DIAGRAMS_URL)" [title]="!isOpen ? ('menu.diagrams' | translate) : ''" [tooltip]="'menu.diagrams' | translate" [tooltipDisabled]="isOpen" tooltipPosition="left">
            <img src="assets/icons/menu/schemas.svg" alt="" class="menu-icon" [class.filter-darkgrey]="!isCurrentPage(DIAGRAMS_URL)">
            @if (isOpen) {
              <span class="menu-label">{{ 'menu.diagrams' | translate }}</span>
            }
            @if (suspended()) {
              <img src="assets/icons/lock-01.svg" alt="" class="lock-icon lock-on-hover">
            }
          </div>
        }

        <!-- Annonces -->
        <div class="menu-item" [class.selected]="isCurrentPage(ANNOUNCEMENT_URL)" [class.collapsed-item]="!isOpen"
          [class.menu-disabled]="!hasAnnouncesRead() && !suspended()" [class.menu-locked]="suspended()"
          (click)="hasAnnouncesRead() && goTo(ANNOUNCEMENT_URL)" [title]="!isOpen ? ('menu.announcement' | translate) : ''" [tooltip]="'menu.announcement' | translate" [tooltipDisabled]="isOpen" tooltipPosition="left">
          <img src="assets/icons/menu/announcements.svg" alt="" class="menu-icon" [class.filter-darkgrey]="!isCurrentPage(ANNOUNCEMENT_URL)">
          @if (isOpen) {
            <span class="menu-label">{{ 'menu.announcement' | translate }}</span>
          }
          @if (suspended()) {
            <img src="assets/icons/lock-01.svg" alt="" class="lock-icon lock-on-hover">
          } @else if (!hasAnnouncesRead()) {
            <img src="assets/icons/lock-01.svg" alt="" class="lock-icon filter-darkgrey">
          }
        </div>

        <!-- Section: Inventaire -->
        <div class="section-label" [class.section-locked]="suspended()" [style.opacity]="isExpanded ? 1 : 0">{{ 'menu.inventory' | translate }}</div>

        <!-- Organisation -->
        <div class="menu-item" [class.selected]="isCurrentPage(ORGANIZATION_URL)" [class.collapsed-item]="!isOpen"
          [class.menu-disabled]="!hasOrganisationRead() && !suspended()" [class.menu-locked]="suspended()"
          (click)="hasOrganisationRead() && goTo(ORGANIZATION_URL)" [title]="!isOpen ? ('menu.organization' | translate) : ''" [tooltip]="'menu.organization' | translate" [tooltipDisabled]="isOpen" tooltipPosition="left">
          <img src="assets/icons/menu/organization.svg" alt="" class="menu-icon" [class.filter-darkgrey]="!isCurrentPage(ORGANIZATION_URL)">
          @if (isOpen) {
            <span class="menu-label">{{ 'menu.organization' | translate }}</span>
          }
          @if (suspended()) {
            <img src="assets/icons/lock-01.svg" alt="" class="lock-icon lock-on-hover">
          } @else if (!hasOrganisationRead()) {
            <img src="assets/icons/lock-01.svg" alt="" class="lock-icon filter-darkgrey">
          }
        </div>

        <!-- Utilisateurs -->
        <div class="menu-item" [class.selected]="isCurrentPage(USERS_USERS_URL)" [class.collapsed-item]="!isOpen"
          [class.menu-disabled]="!hasUserRead() && !suspended()" [class.menu-locked]="suspended()"
          (click)="hasUserRead() && goTo(USERS_USERS_URL)" [title]="!isOpen ? ('menu.users' | translate) : ''" [tooltip]="'menu.users' | translate" [tooltipDisabled]="isOpen" tooltipPosition="left">
          <img src="assets/icons/menu/users.svg" alt="" class="menu-icon" [class.filter-darkgrey]="!isCurrentPage(USERS_USERS_URL)">
          @if (isOpen) {
            <span class="menu-label">{{ 'menu.users' | translate }}</span>
          }
          @if (suspended()) {
            <img src="assets/icons/lock-01.svg" alt="" class="lock-icon lock-on-hover">
          } @else if (!hasUserRead()) {
            <img src="assets/icons/lock-01.svg" alt="" class="lock-icon filter-darkgrey">
          }
        </div>

        <!-- Applications (with count) -->
        <div id="menu-applications" class="menu-item" [class.selected]="isCurrentPage(APPLICATIONS_URL)" [class.collapsed-item]="!isOpen"
          [class.menu-disabled]="!hasApplicationsRead() && !suspended()" [class.menu-locked]="suspended()"
          (click)="hasApplicationsRead() && goTo(APPLICATIONS_URL)" [title]="!isOpen ? ('menu.applications' | translate) : ''" [tooltip]="'menu.applications' | translate" [tooltipDisabled]="isOpen" tooltipPosition="left">
          <img src="assets/icons/menu/applications.svg" alt="" class="menu-icon" [class.filter-darkgrey]="!isCurrentPage(APPLICATIONS_URL)">
          @if (isOpen) {
            <span class="menu-label">{{ 'menu.applications' | translate }}</span>
            @let appsCountValue = appsCount();
            @if (appsCountValue !== undefined && appsCountValue !== 0 && hasApplicationsRead() && !suspended()) {
              <span class="count-badge">
                @if (appsCountValue === null) {
                  <app-unavailable-value></app-unavailable-value>
                } @else {
                  {{ appsCountValue }}
                }
              </span>
            }
          }
          @if (suspended()) {
            <img src="assets/icons/lock-01.svg" alt="" class="lock-icon lock-on-hover">
          } @else if (!hasApplicationsRead()) {
            <img src="assets/icons/lock-01.svg" alt="" class="lock-icon filter-darkgrey">
          }
        </div>

        <!-- Données -->
        <div class="menu-item" [class.selected]="isCurrentPage(DATA_URL)" [class.collapsed-item]="!isOpen"
          [class.menu-disabled]="!hasDataRead() && !suspended()" [class.menu-locked]="suspended()"
          (click)="hasDataRead() && goTo(DATA_URL)" [title]="!isOpen ? ('menu.data' | translate) : ''" [tooltip]="'menu.data' | translate" [tooltipDisabled]="isOpen" tooltipPosition="left">
          <img src="assets/icons/menu/data.svg" alt="" class="menu-icon" [class.filter-darkgrey]="!isCurrentPage(DATA_URL)">
          @if (isOpen) {
            <span class="menu-label">{{ 'menu.data' | translate }}</span>
          }
          @if (suspended()) {
            <img src="assets/icons/lock-01.svg" alt="" class="lock-icon lock-on-hover">
          } @else if (!hasDataRead()) {
            <img src="assets/icons/lock-01.svg" alt="" class="lock-icon filter-darkgrey">
          }
        </div>

        <!-- Infrastructure (with dropdown) -->
        <!-- <app-dropdown #infraMenu> is declared near the bottom of the template
        for the same reason as #analyseMenu — `overlay-scrollbars` clips any
        submenu that opens outside its viewport. -->
        <div class="menu-item" [class.selected]="isCurrentPage(INFRASTRUCTURE_URL) || isCurrentPage(DEVICES_URL)" [class.collapsed-item]="!isOpen"
          [class.menu-disabled]="!hasInfrastructureRead() && !suspended()" [class.menu-locked]="suspended()"
          [dropdownTrigger]="hasInfrastructureRead() && !suspended() && !layout.isHandset() ? infraMenu : null"
          (click)="onInfraClick()"
          [title]="!isOpen ? ('menu.infrastructure' | translate) : ''" [tooltip]="'menu.infrastructure' | translate" [tooltipDisabled]="isOpen" tooltipPosition="left">
          <img src="assets/icons/menu/infrastructure.svg" alt="" class="menu-icon" [class.filter-darkgrey]="!(isCurrentPage(INFRASTRUCTURE_URL) || isCurrentPage(DEVICES_URL))">
          @if (isOpen) {
            <span class="menu-label">{{ 'menu.infrastructure' | translate }}</span>
            @if (hasInfrastructureRead() && !suspended()) {
              <img src="assets/icons/chevron-right.svg" alt="" class="submenu-chevron"
                [class.chevron-open]="infraAccordionOpen && layout.isHandset()">
            }
          }
          @if (suspended()) {
            <img src="assets/icons/lock-01.svg" alt="" class="lock-icon lock-on-hover">
          } @else if (!hasInfrastructureRead()) {
            <img src="assets/icons/lock-01.svg" alt="" class="lock-icon filter-darkgrey">
          }
        </div>

        <!-- Sous 960px, le sous-menu se déplie en accordéon dans le flux du
        menu au lieu d'ouvrir le dropdown flottant. -->
        @if (isOpen && layout.isHandset() && infraAccordionOpen && hasInfrastructureRead() && !suspended()) {
          <div class="submenu-accordion">
            <ng-container [ngTemplateOutlet]="infraItems"></ng-container>
          </div>
        }

        <!-- Section: Autres -->
        <div class="section-bottom">
          <div class="section-label" [style.opacity]="isExpanded ? 1 : 0">{{ 'menu.other' | translate }}</div>

          <!-- Suivi des agents -->
          <div class="menu-item" [class.selected]="isCurrentPage(EXTENSION_URL)" [class.collapsed-item]="!isOpen"
            [class.menu-disabled]="!hasAgentRead() && !suspended()" [class.menu-locked]="suspended()"
            (click)="hasAgentRead() && goTo(EXTENSION_URL)" [title]="!isOpen ? ('menu.extension' | translate) : ''" [tooltip]="'menu.extension' | translate" [tooltipDisabled]="isOpen" tooltipPosition="left">
            <img src="assets/icons/menu/extension.svg" alt="" class="menu-icon filter-darkgrey">
            @if (isOpen) {
              <span class="menu-label">{{ 'menu.extension' | translate }}</span>
            }
            @if (suspended()) {
              <img src="assets/icons/lock-01.svg" alt="" class="lock-icon lock-on-hover">
            } @else if (!hasAgentRead()) {
              <img src="assets/icons/lock-01.svg" alt="" class="lock-icon filter-darkgrey">
            }
          </div>

          <!-- Notifications (with dropdown) -->
          <div class="menu-item p-relative" [class.selected]="notifMenuOpened" [class.collapsed-item]="!isOpen" [class.menu-locked]="suspended()"
            [dropdownTrigger]="suspended() ? null : notificationsMenu"
            [title]="!isOpen ? ('menu.notifications' | translate) : ''" [tooltip]="'menu.notifications' | translate" [tooltipDisabled]="isOpen" tooltipPosition="left">
            <img src="assets/icons/menu/notifications.svg" alt="" class="menu-icon filter-darkgrey">
            @if (isOpen) {
              <span class="menu-label">{{ 'menu.notifications' | translate }}</span>
            }
            @if (suspended()) {
              <img src="assets/icons/lock-01.svg" alt="" class="lock-icon lock-on-hover">
            } @else if (unread > 0) {
              <div class="unread-notifications"></div>
            }
          </div>

          <!-- Aide et support -->
          <div class="menu-item" [class.collapsed-item]="!isOpen"
            (click)="goTo(INTERCOM_URL)" [title]="!isOpen ? ('menu.support' | translate) : ''" [tooltip]="'menu.support' | translate" [tooltipDisabled]="isOpen" tooltipPosition="left">
            <img src="assets/icons/menu/support.svg" alt="" class="menu-icon filter-darkgrey">
            @if (isOpen) {
              <span class="menu-label">{{ 'menu.support' | translate }}</span>
            }
          </div>

          <!-- Paramètres -->
          <div class="menu-item" [class.selected]="isCurrentPage(SETTINGS_URL)" [class.collapsed-item]="!isOpen"
            (click)="goTo(SETTINGS_URL)" [title]="!isOpen ? ('menu.settings' | translate) : ''" [tooltip]="'menu.settings' | translate" [tooltipDisabled]="isOpen" tooltipPosition="left">
            <img src="assets/icons/menu/settings.svg" alt="" class="menu-icon" [class.filter-darkgrey]="!isCurrentPage(SETTINGS_URL)">
            @if (isOpen) {
              <span class="menu-label">{{ 'menu.settings' | translate }}</span>
            }
          </div>
        </div>
      </div>
    </overlay-scrollbars>

    <!-- Sticky user section -->
    <div class="user-section" [dropdownTrigger]="userMenu"
      [class.user-section-active]="userMenu.display" [tooltip]="'menu.account' | translate" [tooltipDisabled]="isOpen" tooltipPosition="left">
      <div class="user-avatar">
        <app-display-user-logo [user]="currentUser()" [size]="32"></app-display-user-logo>
        <div class="user-status-dot" [class.active]="selfActive()"></div>
      </div>
      @if (isOpen) {
        <div class="user-info">
          <span class="user-name">{{ userFullName }}</span>
          <span class="user-email">{{ userEmail }}</span>
        </div>
        <img src="assets/icons/chevron-right.svg" alt="" class="user-chevron filter-darkgrey">
      }
    </div>
  </div>

  <!-- Tenant switching dropdown (anchored to the tenant button, opens to the right) -->
  <app-dropdown
    #tenantMenu
    class="tenant-dropdown"
    [alignToTrigger]="true"
    [paddingX]="10"
    [paddingY]="10"
    [radius]="15">
    <app-tenant-switcher-card (closed)="tenantMenu.close()"></app-tenant-switcher-card>
  </app-dropdown>

  <!-- Infrastructure submenu (anchored to the Infrastructure menu item;
  declared outside <overlay-scrollbars> for the same reason). -->
  <app-dropdown
    #infraMenu
    class="submenu-dropdown"
    [alignToTrigger]="true"
    [paddingX]="10"
    [radius]="15"
    [paddingY]="10">
    <div class="flex-column gap-XXS">
      <ng-container [ngTemplateOutlet]="infraItems"></ng-container>
    </div>
  </app-dropdown>

  <!-- Entrées du sous-menu Infrastructure — partagées entre le dropdown
  (desktop) et l'accordéon (mobile). infraMenu.close() est sans effet
  quand le dropdown n'est pas ouvert. -->
  <ng-template #infraItems>
    @if (hasServersRead()) {
      <div class="dropdown-menu-item flex-space-between flex-align-center" [class.active]="isCurrentPage(INFRASTRUCTURE_SERVERS_URL)" (click)="goTo(INFRASTRUCTURE_SERVERS_URL);infraMenu.close()">
        <div class="flex-align-center gap-S">
          <img src="assets/icons/menu/servers.svg" class="menu-icon" [class.filter-darkgrey]="!isCurrentPage(INFRASTRUCTURE_SERVERS_URL)">
          <span>{{ 'menu.servers' | translate }}</span>
        </div>
        @let serverCountValue = serverCount();
        @if (serverCountValue !== undefined) {
          <span class="count-badge">
            @if (serverCountValue === null) {
              <app-unavailable-value></app-unavailable-value>
            } @else {
              {{ serverCountValue }}
            }
          </span>
        }
      </div>
    }
    @if (hasDevicesRead()) {
      <div class="dropdown-menu-item flex-space-between flex-align-center" [class.active]="isCurrentPage(DEVICES_URL)" (click)="goTo(DEVICES_WORKSTATIONS_URL);infraMenu.close()">
        <div class="flex-align-center gap-S">
          <img src="assets/icons/menu/workstations.svg" class="menu-icon" [class.filter-darkgrey]="!isCurrentPage(DEVICES_URL)">
          <span>{{ 'menu.devices' | translate }}</span>
        </div>
        @let deviceCountValue = deviceCount();
        @if (deviceCountValue !== undefined) {
          <span class="count-badge">
            @if (deviceCountValue === null) {
              <app-unavailable-value></app-unavailable-value>
            } @else {
              {{ deviceCountValue }}
            }
          </span>
        }
      </div>
    }
    @if (hasNetworksRead()) {
      <div class="dropdown-menu-item flex-space-between flex-align-center" [class.active]="isCurrentPage(INFRASTRUCTURE_NETWORKS_URL)" (click)="goTo(INFRASTRUCTURE_NETWORKS_URL);infraMenu.close()">
        <div class="flex-align-center gap-S">
          <img src="assets/icons/menu/network.svg" class="menu-icon" [class.filter-darkgrey]="!isCurrentPage(INFRASTRUCTURE_NETWORKS_URL)">
          <span>{{ 'menu.network' | translate }}</span>
        </div>
      </div>
    }
  </ng-template>

  <!-- Notifications dropdown -->
  <app-dropdown
    #notificationsMenu
    class="notifications-dropdown"
    [alignToTrigger]="true"
    [openAbove]="true"
    (opened)="notifMenuOpened = true"
    (closed)="notifMenuOpened = false"
    [paddingX]="10"
    [paddingY]="10"
    [radius]="15">
    <div class="dropdown-card notifications-dropdown-card">
      @if (notificationsError(); as error) {
        <app-error-state class="empty-notification" size="compact" [error]="error" (retry)="retryNotifications()"></app-error-state>
      } @else if (notifications && notifications.length <= 0) {
        <div class="flex-center gap-S empty-notification">
          <img ngSrc="assets/icons/coming-soon.svg" height="18" width="19" alt="">
          <span class="grey">{{ 'global.noNotification' | translate }}</span>
        </div>
      } @else if (notifications && notifications.length > 0) {
        <div class="notifications-list">
          @for (notification of notifications; track notification) {
            <div class="notification-row p-relative" (click)="redirectToNotificationEntity(notification)">
              @if (notification.status === 'unread') {
                <div class="notif-bubble"></div>
              }
              <div class="single-notification disp-f a-i-c j-c-sb" [ngClass]="{'unread': notification.status === 'unread' }">
                <div class="disp-f a-i-c gap-S pl-l" style="width: 70%;">
                  <div class="avatar disp-f a-i-c j-c-c">
                    <span class="font-M fw-500">{{ notification.sender.firstName.charAt(0) }}{{ notification.sender.lastName.charAt(0) }}</span>
                  </div>
                  <div class="font-S fw-500">
                    <span [innerHTML]="'global.notifications.' + notification.type | translate: { sender: notification.sender.firstName + ' ' + notification.sender.lastName, application: notification.applicationName }"></span>
                  </div>
                </div>
                <div class="font-S grey text-end pr-l" style="width: 30%;">{{ notification.date.toLocaleDateString() }} {{ notification.date.toLocaleTimeString() }}</div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </app-dropdown>

  <!-- User dropdown (anchored to the user section, opens upward to the right) -->
  <app-dropdown
    #userMenu
    class="user-dropdown"
    [alignToTrigger]="true"
    [paddingX]="10"
    [paddingY]="10"
    [radius]="15"
    [openAbove]="true">
    <app-user-menu-card (closed)="userMenu.close()"></app-user-menu-card>
  </app-dropdown>
</div>
